import { isoWeekday } from '@src/utils';

function getBuisnessHoursForResrouce(resource) {
  let buisinessHours = [];
  if (!resource.worktime || !resource.worktime.length) {
    return buisinessHours;
  }
  const toMinutes = (t) => {
    if (!t) {
      return null; 
    }
    const [hh, mm] = t.split(':').map(Number);
    return (hh * 60) + mm;
  };

  const fromMinutes = (m) => {
    const h = Math.floor(m / 60);
    const min = m % 60;
    return `${h}:${min.toString().padStart(2, '0')}`;
  };

  const intervals = [];
  for (const row of resource.worktime || []) {
    const day = row.dewt_weekday;

    const ms = toMinutes(row.dewt_start_time_morning);
    const me = toMinutes(row.dewt_end_time_morning);
    if (ms != null && me != null && me > ms) {
      intervals.push({ start: ms, end: me, day });
    }

    const as = toMinutes(row.dewt_start_time_afternoon);
    const ae = toMinutes(row.dewt_end_time_afternoon);
    if (as != null && ae != null && ae > as) {
      intervals.push({ start: as, end: ae, day });
    }
  }

  const map = new Map();
  for (const it of intervals) {
    const key = `${it.start}-${it.end}`;
    if (!map.has(key)) {
      map.set(key, { start: it.start, end: it.end, days: new Set() });
    }
    map.get(key).days.add(it.day);
  }

  buisinessHours = Array.from(map.values()).map(({ start, end, days }) => ({
    startTime: fromMinutes(start),
    endTime: fromMinutes(end),
    daysOfWeek: Array.from(days).sort((a, b) => a - b),
  }));

  buisinessHours.sort((a, b) => {
    const sa = a.startTime.split(':').reduce((h, i) => (h * 60) + +i);
    const sb = b.startTime.split(':').reduce((h, i) => (h * 60) + +i);
    if (sa !== sb) {
      return sa - sb; 
    }
    const ea = a.endTime.split(':').reduce((h, i) => (h * 60) + +i);
    const eb = b.endTime.split(':').reduce((h, i) => (h * 60) + +i);
    return ea - eb;
  });
  return buisinessHours;
};

function buildResourcesHierarchy(users, {
  idKey = 'user_id',
  managerKey = 'manager',
  childrenKey = 'children',
} = {}) {
  const nodeById = new Map();
  for (const u of users) {
    const clone = { ...u, [childrenKey]: [] };
    nodeById.set(clone[idKey], clone);
  }

  const roots = [];

  for (const u of users) {
    const node = nodeById.get(u[idKey]);
    const managerId = u[managerKey];

    if (managerId == null || !nodeById.has(managerId)) {
      // No manager or manager missing -> root
      roots.push(node);
    }
    else {
      nodeById.get(managerId)[childrenKey].push(node);
    }
  }

  return roots;
}

export function usersToCalendarResources(users, currentUser) {
  if (!users?.length) {
    return [];
  }
  const tree = buildResourcesHierarchy(users.map((item) => {
    const idStr = `user-${String(item.id)}`;
    const title = (item) => {
      if (item.user_family_name && item.user_first_name) {
        return `${item.user_family_name}, ${item.user_first_name}`;
      }
      else {
        return item.name; 
      }
    };
    const resource = {
      id: idStr,
      user_id: item.id,
      title: title(item),
      businessHours: getBuisnessHoursForResrouce(item),
      manager: item.user_manager,
      order: 2,
    };
    if (item.id === currentUser.id) {
      resource.manager = null;
      resource.order = 0;
    }
    if (item.id === currentUser.user_manager) {
      resource.order = 1;
    }
    return resource;
  }));
  return tree;
}

export function getUserWorktimeForDate(userId, users, date) {
  if (!userId || !users || !users.length || !date) {
    return null;
  }

  const user = users.find((u) => u.id === userId);
  if (!user || !user.worktime || !user.worktime.length) {
    return null;
  }

  const dayNumber = isoWeekday(date);
  const dayWorkingTime = user.worktime.find((w) => w.dewt_weekday === dayNumber);
  if (!dayWorkingTime) {
    return null;
  }
  const startTime = dayWorkingTime.dewt_start_time_morning.slice(0, 5); // no seconds
  const endTime = dayWorkingTime.dewt_end_time_afternoon.slice(0, 5); // no seconds
  return { start: startTime, end: endTime};
}
